export enum CustomPDFReportModuleSize {
    QUARTER_PAGE_BY_QUARTER_PAGE = 'quarter_page_by_quarter_page',
    HALF_PAGE_BY_EIGHTH_PAGE = 'half_page_by_eighth_page',
    FULL_PAGE_BY_EIGHTH_PAGE = 'full_page_by_eighth_page',
    HALF_PAGE_BY_QUARTER_PAGE = 'half_page_by_quarter_page',
    FULL_PAGE_BY_QUARTER_PAGE = 'full_page_by_quarter_page',
    HALF_PAGE_BY_HALF_PAGE = 'half_page_by_half_page',
    FULL_PAGE_BY_HALF_PAGE = 'full_page_by_half_page',
    FULL_PAGE_BY_FULL_PAGE = 'full_page_by_full_page',
}

export enum CustomPDFReportModuleCategory {
    INTRODUCTION_AND_BASIC_INFO = 'Introduction & Basic Info',
    PERFORMANCE = 'Performance',
    RISK = 'Risk',
    ALLOCATIONS = 'Allocations',
    PROPOSALS_AND_SCENARIOS = 'Proposals & Scenarios',
    HOLDINGS = 'Holdings',
    ATTRIBUTION_ANALYSIS = 'Attribution Analysis',
    CHARTS_AND_TABLES = 'Charts & Tables',
    DISCLOSURES = 'Disclosures',
}

export enum CustomPDFReportModuleFieldType {
    BOOLEAN = 'BooleanField',
    CHAR = 'CharField',
    CUSTOM_TEXT = 'CustomTextField',
    IMAGE = 'ImageField',
    INFO_LIST = 'InfoListField',
    SELECT = 'SelectField',
    METRIC = 'MetricField',
    METRICS_LIST = 'MetricsListField',
    METRIC_GROUPS = 'MetricGroupsField',
    MULTI_SELECT = 'MultiSelectField',
    SAVED_ASSET_OPTIONS = 'SavedAssetOptions',
    SAVED_ITEM_FIELD = 'SavedItemField',
    SECURITY = 'SecurityField',
    SECURITY_LIST = 'SecurityListField',
    SELECT_TALKING_POINTS = 'SelectTalkingPointsField',
    STRESS_TEST = 'StressTestsField',
    TALKING_POINTS = 'TalkingPointsField',
    RADIO_GROUP = 'RadioGroupField',
    SELECT_TRANSITION_ANALYSIS = 'SelectTransitionAnalysisField',
    SELECT_WITH_CUSTOM_VALUE = 'SelectWithCustomValueField',
    RISK_PROFILES = 'RiskProfilesListField',
    RISK_METRIC_FIELD = 'RiskMetricField',
}
